
const defaults = {
    audioState: 'stopped',
    dataUrl: '',
    currentTime: 0,
    autoPlayNext: true,
    playbackRate: '1.0'
}


export default (state=defaults, action) => {
    switch(action.type){
        case 'AUDIO_SET_PLAYBACK_RATE':
            return {...state, playbackRate: action.payload};
        case 'AUDIO_LOAD':{
            return {...state, 
                audioState: 'load',
                dataUrl: action.payload.dataUrl,
                // currentTime: 0,
                autoPlayNext: true
            }
        }
        case 'AUDIO_STOP':{
            return {...state, 
                audioState: 'stop', 
                autoPlayNext: false
            }
        }
        case 'AUDIO_STOPPED':{
            return {...state, 
                audioState: 'stopped'
            }
        }
        case 'AUDIO_PLAYING':{
            return {...state, 
                audioState: 'playing'
            }
        }
        case 'AUDIO_SEEK':{
            return {...state, 
                audioState: 'seek',
                currentTime: action.payload.time
            }
        }
        case 'PAGE_INIT':
        case 'TOP_VIDEO_PLAY':
        case 'SHOW_VIDEO_PLAYER':
        case 'RECORDER_START_RECORD':
            if(state.audioState !== 'stopped'){
                return {...state, 
                    audioState: 'stop', 
                    autoPlayNext: false
                }
            }else{
                if(state.autoPlayNext){
                    return {...state, autoPlayNext: false}
                }
                return state
            }
        case 'AUDIO_TIME_UPDATE':{
            return {...state, 
                currentTime: action.payload.time
            }
        }
        default:
            return state
    }
} 




// WEBPACK FOOTER //
// ./src/reducers/audioPlayer.js